import { PAGE_VIEW_TYPE } from "./page-view-event";

export function onlyPageViews(type: string): boolean {
    return type.toUpperCase() === PAGE_VIEW_TYPE.toUpperCase();
}
